import * as yup from 'yup'

const getCombinedSchema = (options = {}) => {
  const { onlyReportVersion = false, hasCurrentVersion = false } = options

  let schema = {
    documentId: yup.number().required().typeError('Selecione um documento'),
    documentVersionId: yup
      .string()
      .required()
      .typeError('Selecione uma versão'),
  }

  if (!onlyReportVersion) {
    schema = {
      ...schema,
      exportFormat: yup
        .string()
        .required('Selecione um formato de exportação.'),
      dataAction: yup.string().when('$hasCurrentVersion', {
        is: true,
        then: yup.string().required('Selecione uma ação para o relatório.'),
        otherwise: yup.string().nullable(),
      }),
    }
  }

  return yup.object().shape(schema)
}

export default getCombinedSchema
